import React, { useEffect, useState } from "react";
import {
  useGetCategoriesQuery,
  useGetMenuListQuery,
} from "../../products/productSlice";

import "./ProductsCategory.css";
import axios from "axios";
import Slider from "react-slick";

import service1 from "../../../assets/img/rki/network/1.png";
import service2 from "../../../assets/img/rki/network/2.png";
import service3 from "../../../assets/img/rki/network/3.png";
import service4 from "../../../assets/img/rki/network/4.png";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { base_url } from "../../../server";

const categoriesItems = [
  { id: "1", imgUrls: service1, url: "maintenance-stairs", title: "GGAS Maintenance Stairs" },
  { id: "2", imgUrls: service2, url: "service-carts", title: "GGAS Service Carts" },
  { id: "3", imgUrls: service3, url: "tool-solutions", title: "Tool Solutions" },
  { id: "4", imgUrls: service4, url: "tool-control-solutions", title: "Tool Control Solutions" },
];

function ProductsCategory() {
  // const { isLoading, error } = useGetCategoriesQuery();

  const [categoriesDatas, setCateData] = useState(null);
  const baseUrl = base_url();
  const getcateData = async () => {
    try {
      const res = await axios.get(`${baseUrl}category/public`, {
        withCredentials: true,
      });
      setCateData(res.data);
    } catch (error) {}
  };
  useEffect(() => {
    getcateData();
  }, []);

  const settings = {
    speed: 500,
    slidesToShow: 4, // Number of items to show on desktop
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // Screen size for tablets
        settings: {
          slidesToShow: 4, // Number of items to show on tablets
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991, // Screen size for mobile devices
        settings: {
          slidesToShow: 2, // Number of items to show on mobile
          slidesToScroll: 1,
          // arrows: false,
        },
      },
      {
        breakpoint: 450, // Screen size for mobile devices
        settings: {
          slidesToShow: 1, // Number of items to show on mobile
          slidesToScroll: 1,
          // arrows: false,
        },
      },
    ],
  };

  const { t, i18n } = useTranslation();
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="fisherman-content">
                <h6>Shop with us</h6>
                <h3> {t("Shop by category")}</h3>
              </div>
            </div>

            <div className="row">
              {/* {isLoading && (
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {error && (
                <h4 style={{ textAlign: "center", color: "red" }}>
                  Server Error
                </h4>
              )} */}
            </div>
            <div className="categoryWrapper d-none">
              <Slider {...settings}>
                {categoriesDatas?.slice(0, 9).map((item, i) => {
                  return (
                    <div className="mediaQuaryClas" key={i}>
                      <Link to={`/product/category/${item.uid}/${item?.slug}`}>
                        <div className="serviceItemIcon">
                          <img
                            src={item?.icon?.url}
                            alt="Product"
                            className="img-fluid"
                          />
                        </div>
                        <div className="serviceItemText">
                          <h5>
                            <Link to="/products">
                              {item?.name}
                              <i className="ri-arrow-right-up-fill"></i>
                            </Link>
                          </h5>
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </Slider>
            </div>

            <div className="categoryWrapper">
              <Slider {...settings}>
                {categoriesItems?.map((item) => {
                  return (
                    <div className="mediaQuaryClas" key={item.id}>
                      {/* <Link to={`/product/category/${item.uid}/${item?.slug}`}> */}
                      <Link to={`/${item?.url}`}>
                        <div className="categoryCard">
                          <div className="serviceItemIcon">
                            <img
                              src={item.imgUrls}
                              alt="Product"
                              className="img-fluid"
                            />
                            <div className="serviceItemText">
                              <h5>
                                <Link to="/products">
                                  {item.title}
                                  <i className="ri-arrow-right-up-fill"></i>
                                </Link>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductsCategory;
